import { FormSelect, FormTextInput, useFormContext } from "@jsq/ds/forms";
import { capitalizeEachWord } from "~/utils/strings";
import { AIFieldLabel } from "../../../../../Common/AIFieldLabel";
import { FormValues } from "../../../../../CreateCaseForm/types";
import { AddressFieldNames } from "../constants";
import { UsTerritories } from "./constants";
import { checkIsUsCountrySelected } from "./utils";

interface Props {
  isFull?: boolean;
  placeholder?: string;
  isUs?: boolean;
  populatedByAI?: boolean;
}

const StateFormField = ({ isFull, placeholder = "", populatedByAI = false }: Props) => {
  const { values } = useFormContext<FormValues>();
  const fieldName = AddressFieldNames.StateOrProvince;

  return checkIsUsCountrySelected(values.country) ? (
    <FormSelect
      data-testid="select-state"
      name={fieldName}
      label={<AIFieldLabel label="State/province" showIcon={populatedByAI} />}
      full={isFull}
      placeholder={placeholder}
    >
      <FormSelect.Section>
        {UsTerritories.map((territory) => (
          <FormSelect.Option key={territory.code} value={territory.code.toUpperCase()}>
            {capitalizeEachWord(territory.name)}
          </FormSelect.Option>
        ))}
      </FormSelect.Section>
    </FormSelect>
  ) : (
    <FormTextInput
      isFullWidth={isFull}
      label={<AIFieldLabel label="State/province" showIcon={populatedByAI} />}
      name={fieldName}
      placeholder={placeholder}
      data-testid="state-input"
    />
  );
};

export default StateFormField;
